export default "__VITE_ASSET__de255d59__"